import React from 'react';

import { EMPLOYERS_DEFAULT_PIN_SETTINGS_FORM_VALUES } from '@clearverify/constants';

import { useNotification } from 'src/hooks/app';
import { useCurrentUserEmployer, useEmployerById } from 'src/hooks/employer';

import { EmployeeSettingsForm } from '../EmployeeSettingsForm';
import { SettingsFormFields, SettingsFormValues } from '../EmployeeSettingsForm/types';

export const EmployerSettingsForm: React.FC = () => {
  const { employerId } = useCurrentUserEmployer();
  const { createApolloContext } = useNotification();

  const { employer, updateEmployer } = useEmployerById(employerId);

  const onSubmit = React.useCallback(
    async (data: SettingsFormValues) => {
      try {
        const { signUpMethod } = data;

        await updateEmployer({
          data: {
            signUpMethod,
            ...EMPLOYERS_DEFAULT_PIN_SETTINGS_FORM_VALUES,
          },
          context: createApolloContext({
            successMessage: 'Changes are saved successfully',
          }),
        });
      } catch (error) {
        if (error instanceof Error) {
          console.error(error);
        } else {
          console.error(error);
        }
      }
    },
    [createApolloContext, updateEmployer],
  );

  const initialValues: SettingsFormValues = React.useMemo(
    () => ({
      [SettingsFormFields.signUpMethod]: employer?.signUpMethod,
    }),
    [employer?.signUpMethod],
  );

  return <EmployeeSettingsForm onSubmit={onSubmit} initialValues={initialValues} />;
};
